import React, { Component } from 'react';


class AboutUs extends Component {
   render() {
      return (
        <React.Fragment>
            <p id="title">About EMS</p>
            <p>
                <span className="comp-name">Experts Service Management LLC</span> is a comprehensive Facility Management 
                Company aiming to go with service management to higher levels.
            </p>
            <p>
                With many years of experience in the corporate sector and in managing high 
                end Integrated Tourism Complexes, we come with awareness of what are the 
                clients’ needs. <span className="comp-name">Experts Service Management LLC</span> provides its clients with 
                consultancy and advices as well as it provides them with planned preventive 
                maintenance solutions in order to make sure their properties and facilities 
                are well managed at all times.
            </p>
            <p>
                We believe that professional customer service is a fundamental element in 
                our business and a key factor to achieve success in delivering what the 
                client needs. We emphasize on providing well trained personnel along with 
                developing CAFM system that allows us to interact directly with the client. 
                Efficient communication is key to fulfil our client’s requirements.
            </p>
        </React.Fragment>
      );
   }
}

export default AboutUs;